import React from "react";

const Link = ({
  id = "",
  label,
  onClick,
  onKeyDown,
  tabIndex = 0,
  href = "#",
  role,
  dataTestId,
}) => {
  return (
    <a
      href={href}
      className="cursor-pointer focus-ring link-primary"
      onClick={onClick}
      onKeyDown={onKeyDown}
      tabIndex={tabIndex}
      role={role}
      data-testid={dataTestId || id}
    >
      {label}
    </a>
  );
};

export default Link;
